import { jsx, jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Callout, Card, Intent } from "@blueprintjs/core";
import immer, { setAutoFreeze } from "immer";
import { flatMap, forEach } from "lodash-es";
import { ReactSelectField } from "./FormComponents";
import showConfirmationDialog from "./showConfirmationDialog";
import { startCase } from "lodash-es";
import { typeToCommonType } from "./typeToCommonType";
import { camelCase } from "lodash-es";
import { change } from "redux-form";
import { useDispatch } from "react-redux";
setAutoFreeze(false);
export const MatchHeaders = ({
  csvValidationIssue,
  datatableFormName,
  datatableFormNames: _datatableFormNames,
  doAllFilesHaveSameHeaders,
  fileIndex,
  filesWIssues,
  ignoredHeadersMsg,
  matchedHeaders,
  onMultiFileUploadSubmit,
  reduxFormEntitiesArray,
  searchResults,
  setFilesWIssues,
  userSchema
}) => {
  const datatableFormNames = _datatableFormNames || [datatableFormName];
  const dispatch = useDispatch();
  const flippedMatchedHeaders = useMemo(() => {
    const _flippedMatchedHeaders = {};
    forEach(matchedHeaders, (v, k) => {
      if (v) _flippedMatchedHeaders[v] = k;
    });
    return _flippedMatchedHeaders;
  }, [matchedHeaders]);
  return /* @__PURE__ */ jsxs("div", { style: { maxWidth: 500 }, children: [
    !onMultiFileUploadSubmit && /* @__PURE__ */ jsx(Callout, { style: { width: "fit-content" }, intent: "warning", children: csvValidationIssue }),
    !onMultiFileUploadSubmit && ignoredHeadersMsg && /* @__PURE__ */ jsx(Callout, { style: { width: "fit-content" }, intent: "warning", children: ignoredHeadersMsg }),
    /* @__PURE__ */ jsx("br", {}),
    /* @__PURE__ */ jsxs(
      "tr",
      {
        style: {
          display: "flex",
          minHeight: 50,
          alignItems: "center",
          justifyContent: "space-between"
        },
        children: [
          /* @__PURE__ */ jsx(
            "td",
            {
              style: {
                width: 200,
                marginLeft: 20,
                display: "flex",
                fontWeight: "bold"
              },
              children: "Accepted Headers"
            }
          ),
          /* @__PURE__ */ jsx(
            "td",
            {
              style: {
                width: 200,
                marginLeft: 20,
                display: "flex",
                fontWeight: "bold"
              },
              children: "Your Headers"
            }
          ),
          /* @__PURE__ */ jsx(
            "td",
            {
              style: {
                fontWeight: "bold",
                marginLeft: 30
              },
              children: "Data Preview"
            }
          )
        ]
      }
    ),
    searchResults.map(({ path, displayName, type }, i) => {
      const userMatchedHeader = matchedHeaders[path];
      const opts = flatMap(userSchema.fields, ({ path: pathInner }) => {
        if (pathInner !== userMatchedHeader && flippedMatchedHeaders[pathInner]) {
          return [];
        }
        return {
          value: pathInner,
          label: pathInner
        };
      }).sort((a, b) => {
        const ra = searchResults[i].matches.map((m) => m.item.path).indexOf(a.value);
        const rb = searchResults[i].matches.map((m) => m.item.path).indexOf(b.value);
        if (!ra) return -1;
        if (!rb) return 1;
        return rb - ra;
      });
      return /* @__PURE__ */ jsx(Card, { style: { padding: 2 }, children: /* @__PURE__ */ jsx("table", { children: /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsxs(
        "tr",
        {
          style: {
            display: "flex",
            minHeight: 50,
            alignItems: "center",
            justifyContent: "space-between"
          },
          children: [
            /* @__PURE__ */ jsx(
              "td",
              {
                style: {
                  width: 200,
                  display: "flex"
                },
                children: /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      paddingTop: 2,
                      marginLeft: 15,
                      fontSize: 15
                    },
                    children: /* @__PURE__ */ jsx(
                      "span",
                      {
                        "data-tip": `Column Type: ${typeToCommonType[type || "string"] || type}`,
                        children: displayName || startCase(camelCase(path))
                      }
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx("td", { style: { width: 200 }, children: /* @__PURE__ */ jsx(
              ReactSelectField,
              {
                noMarginBottom: true,
                tooltipError: true,
                beforeOnChange: async () => {
                  const clearEntities = () => {
                    datatableFormNames.forEach((name) => {
                      dispatch(change(name, "reduxFormEntities", null));
                    });
                  };
                  if (reduxFormEntitiesArray.some((r) => r?.isDirty)) {
                    const doAction = await showConfirmationDialog({
                      text: "Are you sure you want to edit the columm mapping? This will clear any changes you've already made to the table data",
                      intent: Intent.DANGER,
                      confirmButtonText: "Yes",
                      cancelButtonText: "No"
                      // canEscapeKeyCancel: true //this is false by default
                    });
                    if (doAction) {
                      clearEntities();
                    } else {
                      return { stopEarly: true };
                    }
                  } else {
                    clearEntities();
                    return { stopEarly: false };
                  }
                },
                onChange: (val) => {
                  setFilesWIssues(
                    immer(filesWIssues, (files) => {
                      files.forEach((f, i2) => {
                        const isCurrentFile = fileIndex === i2;
                        if (isCurrentFile || doAllFilesHaveSameHeaders) {
                          f.matchedHeaders[path] = val;
                        }
                      });
                    })
                  );
                },
                name: path,
                defaultValue: userMatchedHeader,
                options: opts
              }
            ) }),
            /* @__PURE__ */ jsx(
              "td",
              {
                style: {
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  fontSize: 10
                  /* color: Colors.RED1 */
                },
                children: userMatchedHeader && [
                  // { [userMatchedHeader]: "Preview:" },
                  ...userSchema.userData?.slice(0, 3) || []
                  // { [userMatchedHeader]: "..." }
                ].map((row, i2) => {
                  return /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        maxWidth: 70,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      },
                      children: row?.[userMatchedHeader] || ""
                    },
                    `userMatchedHeader-${i2}`
                  );
                })
              }
            )
          ]
        }
      ) }) }) }, `field-${i}`);
    })
  ] });
};
